import { Alert } from '@mui/material';

const WarningAlert = ({ children, sx, ...props }) => (
  <Alert
    severity="warning"
    sx={{
      alignItems: 'flex-start',
      backgroundColor: 'rgba(255, 184, 77, 0.12)',
      border: '1px solid rgba(255, 184, 77, 0.28)',
      color: '#F5E3C6',
      borderRadius: '8px',
      '& .MuiAlert-icon': {
        color: '#FFB84D',
      },
      ...sx,
    }}
    {...props}>
    {children}
  </Alert>
);

export default WarningAlert;
